<div mdbModal #realizarAjuste="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-fluid" style="max-width: 90%" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Ajuste de Inventario Físico
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="realizarAjuste.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row align-items-center">
          <div class="col dato" style="max-width: 200px">
            <Strong class="title">Nro. Doc.</Strong>
            <span class="value">{{movimiento?.codigo}}</span>
          </div>
          <div class="col dato" style="max-width: 200px">
            <Strong class="title">Bodega</Strong>
            <span class="value">{{movimiento?.bodega_nombre | numerico}}</span>
          </div>

          <div class="col dato" style="max-width: 200px">
            <Strong class="title">Estado</Strong>
            <span class="value">{{movimiento?.estado_inventario_nombre | numerico}}</span>
          </div>

          <form [formGroup]='formDetails' novalidate class="d-flex">
          <div class="col" style="max-width: 200px">
            <div class="md-form">
              <input value="" type="text" id="codProduct" class="form-control" placeholder="000" required #codProduct
                formControlName="codigo" onlyNumbers />
              <label for="codProduct">Código de producto</label>
              <!-- <div *ngIf="
                                        formDetails.get('codigo').invalid &&
                                        (formDetails.get('codigo').dirty ||
                                        formDetails.get('codigo').touched)
                                    ">
                                      <mdb-error *ngIf="formDetails.get('codigo').hasError('required')">
                                        Ingrese código de producto
                                      </mdb-error>
                                    </div> -->
            </div>
          </div>
          <div class="col">
            <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect (click)="filtrarProducto()">
              <mdb-icon fas icon="search"></mdb-icon>
            </button>
          </div>
          </form>
          
        </div>

        

        <mdb-spinner spinnerColor="blue" *ngIf="loading"></mdb-spinner>

        <table class="table table-striped table-hover table-sm align-middle" *ngIf="detalleDocumento?.length > 0">
          <thead class="grey lighten-2">
            <tr>
              <th scope="col" style="width: 150px;">
                <mdb-checkbox [(ngModel)]="checkAll" (change)="checkAllChange($event)">SKU</mdb-checkbox>
              </th>
              <th scope="col">Producto</th>
              <th scope="col">Formato</th>
              <th scope="col" class="text-right">Saldo Actual</th>
              <th scope="col" class="text-right">Inv. Físico</th>
              <th scope="col" class="text-right">Cant. Ent.</th>
              <th scope="col" class="text-right">Cant. Sal</th>
              <th scope="col" class="text-right">Precio</th>
              <th scope="col" class="text-right">Valor Dif.</th>
            </tr>
          </thead>
          <tbody>
            <!-- <tr>
              <td>
                <mdb-checkbox></mdb-checkbox>
              </td>
              <td>1231232128</td>
              <td>Cassata</td>
              <td>Caja</td>
              <td align="right">100</td>
              <td align="right" class="text-success">100</td>
              <td align="right">0</td>
            </tr>
            <tr>
              <td>
                <mdb-checkbox></mdb-checkbox>
              </td>
              <td>1231232128</td>
              <td>Cassata</td>
              <td>Caja</td>
              <td align="right">56</td>
              <td align="right" class="text-success">569</td>
              <td align="right" class="text-info">3</td>
            </tr>
            <tr>
              <td>
                <mdb-checkbox></mdb-checkbox>
              </td>
              <td>1231232128</td>
              <td>Cassata</td>
              <td>Caja</td>
              <td align="right">700</td>
              <td align="right" class="text-success">650</td>
              <td align="right" class="text-danger">-50</td>
            </tr> -->
            <tr *ngFor="let doc of detalleDocumento">
              <td>
                <mdb-checkbox [checked]="doc.additionalInfo.checked" (change)='checkDetalle(doc.additionalInfo)'>
                  {{doc.sku}}
                </mdb-checkbox>
              </td>
              <td>{{doc.producto_nombre}}</td>
              <td>{{doc.formato_nombre}}</td>
              <td class="text-right">{{doc.cantidad_saldo | numerico}}</td>
              <td class="text-right text-success">{{doc.cantidad_contada | numerico}}</td>
              <td class="text-right" *ngIf="doc.cantidad_diferencia === 0">{{doc.cantidad_diferencia | numerico}}</td>
              <td class="text-right text-info" *ngIf="doc.cantidad_diferencia > 0">{{doc.cantidad_diferencia |
                numerico}}</td>
              <td class="text-right" *ngIf="doc.cantidad_diferencia < 0">0</td>
              <td class="text-right" *ngIf="doc.cantidad_diferencia === 0">{{doc.cantidad_diferencia | numerico}}</td>
              <td class="text-right" *ngIf="doc.cantidad_diferencia > 0">0</td>
              <td class="text-right text-danger" *ngIf="doc.cantidad_diferencia < 0">{{doc.cantidad_diferencia |
                numerico}}</td>
              <td class="text-right">{{doc.precio_costo | numerico}}</td>
              <td class="text-right">{{doc.valor_dif | numerico}}</td>
            </tr>
            <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
              *ngIf="detalleDocumento?.length > 0"></app-pagination>
          </tbody>
          <tbody class="blue lighten-5">
            <tr>
              <td class="text-right" colspan="5">
                <strong>Cant. Prod.</strong>
              </td>
              <td>{{inventario_totales.cantidad | numerico}}</td>
              <!-- <td class="text-right"><strong></strong></td> -->
              <td class="text-right" colspan="2">
                <strong>Total Diferencia $</strong>
              </td>
              <td>{{inventario_totales.total_dif | numerico}}</td>
              <!-- <td class="text-right"><strong></strong></td> -->
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer justify-content-between">
        <button size="sm" type="button" class="btn btn-sm btn-default waves-light" data-dismiss="modal"
          (click)="realizarAjuste.hide()" mdbWavesEffect>
          Cerrar
        </button>
        <div class="">
          <button size="sm" type="button" class="btn btn-sm btn-success waves-light" mdbWavesEffect
            (click)="generarArchivoExcel()">
            Exportar a Excel
          </button>
          <app-api-button (click2)="guardar()" [processing]="processing">Guardar</app-api-button>
          <!-- <button size="sm" type="button" class="btn btn-sm btn-secondary waves-light" mdbWavesEffect
            (click)="guardar()">
            Guardar
          </button> -->
        </div>
      </div>
    </div>
  </div>
</div>